import { connect } from 'react-redux';

import DebitNotePresentation from './DebitNotePresentation';

import { debitNoteActions } from 'dataflow/billingPortal/actions';

function mapStateToProps(state) {  
    const { userPermissions } = state.userManagementReducers;

	return {
        ...state.debitNoteReducers,
        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getDebitNote: (pageNo, pageSize, sort, filterOptions) => { dispatch(debitNoteActions.getDebitNoteList(pageNo, pageSize, sort, filterOptions)); },
        getAllDebitNote: (pageNo, pageSize, sort, filterOptions) => { dispatch(debitNoteActions.getAllDebitNoteList(pageNo, pageSize, sort, filterOptions)); },

        postDebitNote: (id, date, accountCode) => { dispatch(debitNoteActions.postDebitNote(id, date, accountCode)); },
        knockOffCredit: (id) => { dispatch(debitNoteActions.knockOffCredit(id)); },
        deleteDebitNote: (id) => { dispatch(debitNoteActions.deleteDebitNote(id)); },
    };
}

const DebitNote = connect(mapStateToProps, mapDispatchToProps)(DebitNotePresentation);

export default DebitNote;